/* assets/cart-drawer-advanced.js */
(function () {
  if (window.__RX_CART_DRAWER_INIT__) return;
  window.__RX_CART_DRAWER_INIT__ = true;

  const sel = {
    overlay: '[data-cart-overlay]',
    panel: '.rxCartPanel',
    bg: '.rxCartOverlay__bg',
    root: '[data-cart-root]'
  };
  const qs = (s, r) => (r || document).querySelector(s);
  const onCartPage = () => location.pathname.replace(/\/+$/,'') === '/cart';
  const rootRoute = () => window.Shopify?.routes?.root || '/';

  const Drawer = {
    _overlay: null,
    _root: null,
    _lockCount: 0,
    _previousFocus: null,
    _updating: false,
    _hydrated: false,
    _hydratePromise: null,

    init() {
      this._overlay = qs(sel.overlay);
      this._root = qs(sel.root);
      if (!this._overlay || !this._root) return;

      const bg = qs(sel.bg, this._overlay);
      if (bg) bg.addEventListener('click', () => this.hide());

      document.addEventListener('keydown', (e) => {
        if (!this._overlay.classList.contains('is-active')) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.hide();
          return;
        }
        if (e.key === 'Tab') this.trapFocus(e);
      });

      window.CartDrawer = window.CartDrawer || {};
      window.CartDrawer.show = () => Drawer.show();
      window.CartDrawer.hide = () => Drawer.hide();
      window.CartDrawer.refresh = () => Drawer.hydrate();
      window.CartDrawer.addItem = (payload) => Drawer.addItem(payload);

      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-cart-open], #HeaderCartTrigger');
        if (!t) return;
        if (onCartPage()) return;
        e.preventDefault();
        Drawer.show();
      });

      document.addEventListener('ajaxProduct:added', (event) => {
        if (event?.detail?.preventCartOpen) {
          Drawer.hydrate(true);
          return;
        }
        Drawer.show();
      });

      document.addEventListener('cart:updated', () => Drawer.hydrate(true));
      document.addEventListener('product-form:cart:update', () => Drawer.show());

      const openFullCart = (e) => {
        const reviewBtn = e.target.closest('[data-rx-cart-review]');
        if (!reviewBtn) return false;
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.assign(reviewBtn.getAttribute('data-href') || `${rootRoute()}cart`);
        return true;
      };

      // Run before checkout apps handle the later click event.
      this._overlay.addEventListener('pointerdown', openFullCart, true);
      this._overlay.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') openFullCart(e);
      }, true);

      // Inside-drawer delegation
      this._overlay.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('[data-cart-close]');
        if (closeBtn) { e.preventDefault(); this.hide(); return; }

        const plus = e.target.closest('[data-rx-plus]');
        const minus = e.target.closest('[data-rx-minus]');
        const rem  = e.target.closest('[data-rx-remove]');
        if (!plus && !minus && !rem) return;

        e.preventDefault();
        const row  = e.target.closest('[data-line]');
        const line = row ? parseInt(row.getAttribute('data-line'), 10) : null;
        const qtyEl = row ? row.querySelector('.rxQtyVal') : null;
        const qNow = qtyEl ? parseInt(qtyEl.textContent, 10) : null;
        if (line == null || qNow == null) return;

        if (rem) this.updateLine(line, 0);
        else if (plus) this.updateLine(line, qNow + 1);
        else if (minus) this.updateLine(line, Math.max(1, qNow - 1));
      });

    },

    lockScroll(lock) {
      if (lock) {
        if (this._lockCount++ === 0) {
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
        }
      } else {
        if (this._lockCount > 0 && --this._lockCount === 0) {
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }
      }
    },

    show() {
      if (onCartPage()) return; // hard stop on /cart
      if (!this._overlay) return;
      this._previousFocus = document.activeElement;
      this._overlay.hidden = false;
      void this._overlay.offsetHeight;
      this._overlay.classList.add('is-active');
      this.lockScroll(true);
      this.hydrate().then(() => {
        const firstTarget = this._overlay.querySelector('[data-cart-close], a[href], button:not([disabled]), input:not([disabled])');
        const panel = qs(sel.panel, this._overlay);
        (firstTarget || panel)?.focus();
      });
    },

    hide() {
      if (!this._overlay) return;
      this._overlay.classList.remove('is-active');
      this.lockScroll(false);
      setTimeout(() => {
        if (!this._overlay.classList.contains('is-active')) {
          this._overlay.hidden = true;
          if (this._previousFocus && document.contains(this._previousFocus)) {
            this._previousFocus.focus();
          }
          this._previousFocus = null;
        }
      }, 250);
    },

    trapFocus(event) {
      const focusable = Array.from(this._overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) {
        event.preventDefault();
        qs(sel.panel, this._overlay)?.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    async hydrate(silent) {
      if (!this._root) return;
      if (this._hydratePromise) return this._hydratePromise;
      this._hydratePromise = this._hydrate(silent).finally(() => {
        this._hydratePromise = null;
      });
      return this._hydratePromise;
    },

    async _hydrate(silent) {
      try {
        const res = await fetch(`${rootRoute()}?section_id=cart-drawer-advanced`, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`Cart drawer request failed with ${res.status}`);
        const html = await res.text();

        this._root.innerHTML = html;
        this._hydrated = true;

        const bubbleNum = document.querySelector('.cart-link__bubble-num');
        if (bubbleNum) {
          try {
            const cartRes = await fetch(`${rootRoute()}cart.js`, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
            if (!cartRes.ok) throw new Error(`Cart request failed with ${cartRes.status}`);
            const cart = await cartRes.json();
            const count = cart.item_count || 0;
            bubbleNum.textContent = count;
            const wrap = document.querySelector('.cart-link__bubble');
            if (wrap) wrap.classList.toggle('cart-link__bubble--visible', count > 0);
          } catch (_) {}
        }
      } catch (e) {
        this.announce('The cart could not be refreshed. Please try again.');
        if (!silent) console.warn('CartDrawer hydrate failed', e);
      }
    },

    async addItem(payload) {
      if (!payload || !payload.id) return false;
      const quantity = payload.quantity || 1;
      const properties = payload.properties || {};
      try {
        const response = await fetch(`${rootRoute()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: payload.id, quantity, properties })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Cart add failed');
        }
        this.show();
        document.dispatchEvent(new CustomEvent('rx:cart:added'));
        return true;
      } catch (e) {
        this.announce(e.message || 'The item could not be added. Please try again.');
        console.warn('CartDrawer add failed', e);
        return false;
      }
    },

    async updateLine(line, quantity) {
      if (this._updating) return;
      this._updating = true;
      this._overlay?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${rootRoute()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line, quantity })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Cart update failed');
        }
        await this.hydrate();
        this.announce(quantity === 0 ? 'Item removed from your bag.' : 'Bag quantity updated.');
      } catch (e) {
        this.announce(e.message || 'The cart could not be updated. Please try again.');
        console.warn('CartDrawer update failed', e);
      } finally {
        this._updating = false;
        this._overlay?.removeAttribute('aria-busy');
      }
    },

    announce(message) {
      const status = this._overlay?.querySelector('[data-cart-status]');
      if (status) status.textContent = message;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Drawer.init(), { once: true });
  } else {
    Drawer.init();
  }
})();
